export default __webpack_public_path__ + "static/media/ID10593@2x.214ff579.png";